import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import AppMarket_001 from './img/AppMarket_001.png'

export default class AppMarket extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">应用市场</div>
        <div className="main-window-content">应用市场可下载相关的应用软件</div>
        <img src={AppMarket_001} className="main-window-img"></img>
      </div>
    )
  }
}
